import { render, staticRenderFns } from "./retailers-update-details-button.vue?vue&type=template&id=5241bc6c&"
import script from "./retailers-update-details-button.vue?vue&type=script&lang=js&"
export * from "./retailers-update-details-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports